export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Latin2-0c5955811d85751fb3c3a3f7e1ae9fcc.woff2";